import { SessionFilterViewProps } from './model'
import React, { useEffect, useState } from 'react'
import { SelectOption } from '../SelectDropdown/SelectDropdown'
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import { selectSessionFilterMeetingTemplateIds, setSessionFilterMeetingTemplateIds } from '../../store/sessionFilter/sessionFilter'
import { useGetMeetingTemplatesQuery } from '../../store/ai/meetingTemplate'
import { selectAccountId } from '../../store/auth/authSlice'
import { MultiSelectDropdown } from '../MultiSelectDropdown/MultiSelectDropdown'
import { useSearchParams } from 'react-router-dom'

export const SessionMeetingTemplateFilter: React.FC<SessionFilterViewProps> = ({ disabled = false, onFilterChanged }) => {
  const dispatch = useAppDispatch()
  const accountId = useAppSelector(selectAccountId)
  const sessionFilterMeetingTemplateIds = useAppSelector(selectSessionFilterMeetingTemplateIds)
  const { data: meetingTemplates } = useGetMeetingTemplatesQuery(
    { accountId, pageRequest: { page: 0, size: 500 }, includeInactive: false },
    { refetchOnMountOrArgChange: true },
  )
  const [searchParams, setSearchParams] = useSearchParams()

  const [meetingTemplateOptions, setMeetingTemplateOptions] = useState<SelectOption[]>([])

  useEffect(() => {
    if (meetingTemplates && meetingTemplates.data) {
      setMeetingTemplateOptions(
        meetingTemplates.data
          .map((template) => {
            return { id: template.id, label: template.name }
          })
          .sort((left, right) => left.label.localeCompare(right.label)),
      )
    }
  }, [meetingTemplates])

  const handleMeetingTemplateIdsChanged = (ids: string[]) => {
    ids.length < 1 ? searchParams.delete('meetingTemplates') : searchParams.set('meetingTemplates', JSON.stringify(ids))
    searchParams.delete('filterId')
    onFilterChanged && onFilterChanged(searchParams)
    dispatch(setSessionFilterMeetingTemplateIds(ids))
  }

  return (
    <div>
      <div className='mb-1'>Filter by meeting type {sessionFilterMeetingTemplateIds.length ? `(${sessionFilterMeetingTemplateIds.length})` : null}</div>

      <MultiSelectDropdown
        name='meetingTemplateIds'
        options={meetingTemplateOptions}
        initialSelectedOptions={sessionFilterMeetingTemplateIds}
        onSelectedChanged={handleMeetingTemplateIdsChanged}
        disabled={disabled}
      />
    </div>
  )
}
